import React from 'react'
import { Head, router } from '@inertiajs/react'
import AdminLayout from '../../../components/AdminLayout'
import AdminTable from '../../../components/AdminTable'

interface Provider {
  id: number
  name: string
  offers_count: number
  created_at: string
}

interface Props {
  providers: Provider[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
    prev_page?: number
    next_page?: number
  }
  filters: {
    search?: string
  }
  can_edit: boolean
}

function ProvidersIndex({ providers, pagination, filters, can_edit }: Props) {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'offers_count', label: 'Offers' },
    { key: 'created_at', label: 'Created At' },
  ]

  const formFields = [
    { name: 'name', label: 'Name', type: 'text' as const, required: true }
  ]

  const handleCreate = (formData: any) => {
    router.post('/providers', { provider: formData })
  }

  const handleEdit = (item: any) => {
    const isConfirmed = window.confirm(`Are you sure you want to update the provider "${item.name}"?`)
    if (isConfirmed) {
      router.put(`/providers/${item.id}`, { provider: { name: item.name } })
    }
  }

  const handleDelete = (item: any) => {
    if (item.offers_count > 0) {
      alert('Cannot delete provider with associated offers.')
      return
    }
    
    const isConfirmed = window.confirm(
      `Are you sure you want to delete the provider "${item.name}"?\n\nThis action cannot be undone.`
    )
    if (isConfirmed) {
      router.delete(`/providers/${item.id}`)
    }
  }

  return (
    <>
      <Head title="Providers | Mailkit - Resolute" />
      <AdminTable
        title="Providers"
        description="Manage providers in the system"
        data={providers}
        columns={columns}
        pagination={pagination}
        filters={filters}
        can_edit={can_edit}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={handleDelete}
        searchPlaceholder="Search providers..."
        basePath="/providers"
        formFields={formFields}
      />
    </>
  )
}

ProvidersIndex.layout = page => <AdminLayout>{page}</AdminLayout>

export default ProvidersIndex